import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-submit-jobs',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './submit-jobs.component.html',
  styleUrl: './submit-jobs.component.scss'
})
export class SubmitJobsComponent {

}
